import { isEmpty, isEqual, isString } from 'lodash';
import { i18n } from '@shared/util/i18n';
import { validateEmails } from '@shared/util/validate/email';
import { EditableField, Field } from './Field';

export class EmailField implements EditableField {
  readonly fieldType = 'EmailField';
  readonly emails: string[];

  constructor(emails: string[]) {
    this.emails = emails;
  }

  validate(): string | null {
    if (validateEmails(this.emails)) {
      return null;
    }
    return i18n('workflowTemplate.component.error.email.invalid');
  }

  isEqual(field: Field): boolean {
    return field instanceof EmailField && isEqual(this.emails, field.emails);
  }

  toFieldJson() {
    return this.emails;
  }

  toDisplayString(): string {
    return this.emails.join(', ');
  }

  get isEmpty() {
    return isEmpty(this.emails);
  }

  static fromFieldJson(jsonBlob: any): EmailField | null {
    if (Array.isArray(jsonBlob)) {
      return new EmailField(jsonBlob.filter(isString));
    } else {
      return null;
    }
  }
}
